<template>
  <div class="stock-favorite-view">
    <StockFavorite />
  </div>
</template>

<script>
import StockFavorite from '@/components/favorite/StockFavorite.vue'

export default {
  name: 'StockFavoriteView',
  components: {
    StockFavorite
  }
}
</script>

<style scoped>
.stock-favorite-view {
  padding: 20px;
  flex: 1;
}
</style>
